export enum MovieLanguageCode {
  VoiceOver = 0,
  Dubbed = 1,
  Subtitled = 2,
}

export const MovieLanguageCodeOptions = [
  { value: MovieLanguageCode.VoiceOver, key: 'movies.language_code.vo' },
  { value: MovieLanguageCode.Dubbed, key: 'movies.language_code.db' },
  { value: MovieLanguageCode.Subtitled, key: 'movies.language_code.st' },
];
